import React from "react";

const PrivacyPolicy = () => {
    return (
        <>
            <section className='blog about-blog'>
                <div className='container'>
                    {/* <div className='blog-bradcrum'>
                        <span>
                            <a href='/home'>Home</a>
                        </span>
                        <span className='devider'>/</span>
                        <span>Privacy Policy</span>
                    </div> */}
                    <div className='blog-heading about-heading'>
                        <h1 className='heading'>Privacy Policy</h1>
                    </div>
                </div>
            </section>

            <section>
                <div className="container">
                    <div className="privacy-policy-page">
                        <div className="my-4">
                            <h5 className='ppwrapper-heading'>Privacy Policy</h5>
                            <p className="paragraph">
                                Thank you for visiting Grocji's privacy policy. We provide
                                the best standards in our customer's information privacy and in relation to their secure
                                transactions on Grocji. Please review our privacy policy periodically for updates
                                and feel free to contact us at grocji@gmail.com if you have any questions.
                            </p>
                        </div>
                        <div className="my-4">
                            <h5 className='ppwrapper-heading'>Collection of Your Information</h5>
                            <p className="paragraph">
                                When you setup an account with us, contact us, or participate in activities on our site,
                                we gather personal information from you such as name, e-mail address, mobile phone number,
                                etc. When you visit our site, we may maintain some information about your visit
                                such as your computer's IP, browser type, time visited, etc
                            </p>
                        </div>
                        <div className="my-4">
                            <h5 className='ppwrapper-heading'>Use of your Personal Information</h5>
                            <p className="paragraph">
                                We use personal information to personalize and customize the product and service to you.
                                In addition, we use the information to promote services to you and for product improvement
                                purposes. We also use the information troubleshoot issues; for our safety and to protect
                                us against error, fraud, and crimes; diagnose problems; as advised as time of information
                                collection; and to administer the terms and conditions.
                            </p>
                        </div>
                        <div className="my-4">
                            <h5 className='ppwrapper-heading'>Use of Cookies</h5>
                            <p className="paragraph">
                                Cookies are small identifiers that is sent from a web server to web browser and then
                                stored on your computer's hard drive to identify you and to understand how you arrived
                                at our website. We use both temporary and permanent cookies to maintain your security
                                and improve your experience with our product. A cookie is a text file that is
                                placed on your hard disk by a web page server. Cookies cannot be used to run programs
                                or deliver viruses to your computer. Cookies are uniquely assigned to you, and can
                                only be read by a web server in the domain that issued the cookie to you. One of
                                the primary purposes of cookies is to provide a convenience feature to save you time.
                                The purpose of a cookie is to tell the Web server that you have returned to a specific page.
                                This simplifies the process of recording your personal information, such as billing
                                addresses, shipping addresses, and so on. When you return to the same  website,
                                the information you previously provided can be retrieved, so you can easily use the
                                features that you customized. You have the ability to accept or decline cookies. Most Web browsers
                                automatically accept cookies, but you can usually modify your browser setting to decline cookies
                                if you prefer. If you choose to decline cookies, you may not be able to fully experience the
                                interactive features of the  services or websites you visit. Security We are
                                committed to ensuring that your information is secure. In order to prevent unauthorized
                                access or disclosure, we have put in place suitable physical, electronic and managerial
                                procedures to safeguard and secure the information we collect online.
                            </p>
                        </div>
                        <div className="my-4">
                            <h5 className="ppwrapper-heading">Security</h5>
                            <p className="paragraph">
                                We are concerned about safeguarding the confidentiality of your information.
                                We provide physical, electronic, and procedural safeguards to protect
                                the information we process and maintain. For example, we limit access
                                to this information to authorized employees and contractors who need to know
                                that information in order to operate, develop or improve our Application.
                                Please be aware that, although we endeavor to provide reasonable security
                                for information we process and maintain, no security system can prevent all
                                potential security breaches.
                            </p>
                        </div>
                        <div className="my-4">
                            <h5 className="ppwrapper-heading">Children</h5>
                            <p className="paragraph">
                                We do not use the Application to knowingly solicit data from or market to children
                                under the age of 13. If a parent or guardian becomes aware that his or her child
                                has provided us with information without their consent, he or she should contact us.
                                We will delete such information from our files within a reasonable time.
                            </p>
                        </div>
                        <div className="my-4">
                            <h5 className="ppwrapper-heading">Changes</h5>
                            <p className="paragraph">
                                This Privacy Policy may be updated from time to time for any reason. We will notify
                                you of any changes to our Privacy Policy by posting the new Privacy Policy here and
                                informing you via email or text message. You are advised to consult this Privacy
                                Policy regularly for any changes, as continued use is deemed approval of all
                                changes. You can check the history of this policy by clicking here.
                            </p>
                        </div>
                        <div className="my-4">
                            <h5 className="ppwrapper-heading">Your Consent</h5>
                            <p className="paragraph">
                                By using the Application, you are consenting to our processing of your information
                                as set forth in this Privacy Policy now and as amended by us. “Processing,”
                                means using cookies on a computer/hand held device or using or touching information
                                in any way, including, but not limited to, collecting, storing, deleting, using,
                                combining, and disclosing information, all of which activities will take place
                                in India. If you reside outside India your information will be transferred,
                                processed, and stored there under Indian privacy standards.
                            </p>
                        </div>
                        
                    </div>
                </div>
            </section>
        </>
    )
}
export default PrivacyPolicy;